export const GET_BUYING_PRODUCTS = 'GET_BUYING_PRODUCTS';
export const GET_BOUGHT_PRODUCTS = 'GET_BOUGHT_PRODUCTS';
export const GET_BUY_PRODUCT_DETAILS = 'GET_BUY_PRODUCT_DETAILS'
export const GET_FAVORITE_PRODUCT = 'GET_FAVORITE_PRODUCT'
export const SET_PRODUCT_OBJECTS = 'SET_PRODUCT_OBJECTS'